import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_table-reserve-287/artifacts/axtunzsh_LOGO.PNG";

export default function Brand({ className = "", size = "md" }) {
  const sizes = {
    sm: "h-8",
    md: "h-12",
    lg: "h-16 md:h-20",
    xl: "h-20 md:h-28",
  };
  return (
    <img
      src={LOGO_URL}
      alt="LAMUSIK"
      data-testid="brand-logo"
      className={`${sizes[size]} w-auto select-none ${className}`}
      draggable="false"
    />
  );
}
